function caisseController($uibModal, $translate, $scope, WS, $window) {
    'ngInject';
    const vm = this;
    vm.regions = {};
    vm.current_date = moment().format('YYYY-MM-DD');
    vm.caisse_espece = 0;
    vm.caisse_cheque = 0;
    vm.caisse_credit = 0;
    vm.caisse_creditgms = 0;
    vm.caisse_depense = 0;
    vm.caisse_carburant = 0;
    vm.caisse_entretien = 0;
    vm.caisse_gratuite = 0;
    vm.caisse_recouvrement = 0;
    vm.caisse_versement_banque=0;
    vm.caisse_banque=0;
    vm.caisse_remise=0;
    vm.caisse_avoir=0;
    vm.caisse_dlc=0;
    vm.commentaire='';

    vm.caisse_ticket=0;
    vm.detect_action_disable=false;
    vm.cloture = 0;

    vm.checkControlePassword = () => {
        

        WS.post('users/checkControlePassword', {password : vm.password})
            .then(function(response) {
                if (response.status == 200) {
                    if(response.data.success){
                        vm.cloture = 0;
                    }else{
                        swal(
                            $translate.instant('Oups!'),
                            $translate.instant('Mot de passe non valide!'),
                            'warning'
                        )
                    }
                    $scope.$apply();
                    /*$('.table').DataTable({
                        "language": DatatableLang,
                        order : ['3', 'desc']
                    });*/
                } else {}
            })
            .then(null, function(error) {
                console.log(error);
            });

    }

    
    vm.getCaisses = function() {
        WS.get('caisses/top50')
            .then(function(response) {
                if (response.status == 200) {
                    vm.caisses = response.data;
                    $scope.$apply();
                    /*$('.table').DataTable({
                        "language": DatatableLang,
                        order : ['3', 'desc']
                    });*/
                } else {}
            })
            .then(null, function(error) {
                console.log(error);
            });
    };

    vm.getFirstSousSociete = function() {
        WS.get('soussocietes/first')
            .then(function(response) {
                vm.societe = response.data;
               
                    $scope.$apply();
            })
            .then(null, function(error) {
                console.log(error);
            });
    }

    vm.modifierCaisse = function(caisse) {
        caisse.recette = Number((vm.recette).toFixed(3));
        caisse.recette = caisse.recette.toString().replace(/,/g, '');

        caisse.journee = Number(vm.caisse_espece) +
                        Number(vm.caisse_cheque) +
                        Number(vm.caisse_credit) +
                        Number(vm.creditgms) +
                        Number(vm.caisse_depense) +
                        Number(vm.caisse_carburant) +
                        Number(vm.caisse_entretien) +
                        Number(vm.caisse_gratuite) +
                        Number(vm.caisse_versement_banque) +
                        Number(vm.caisse_remise) +
                        Number(vm.total_tarifs) 
                        - Number(vm.caisse_recouvrement) +
                        Number(vm.caisse_ticket) +
                        Number(vm.caisse_avoir) +
                        Number(vm.caisse_dlc);

        caisse.ecart = Number(caisse.recette) - caisse.journee;

        caisse.espece = vm.caisse_espece;
        caisse.cheque = vm.caisse_cheque;
        caisse.ticket = vm.caisse_ticket;
        caisse.credit = vm.caisse_credit;
        caisse.creditgms = vm.creditgms;
        caisse.depense = vm.caisse_depense;
        caisse.carburant = vm.caisse_carburant;
        caisse.entretien = vm.caisse_entretien;
        caisse.gratuite = vm.caisse_gratuite;
        caisse.recouvrement = vm.caisse_recouvrement;
        caisse.versement_banque = vm.caisse_versement_banque;
        caisse.banque = vm.caisse_banque;
        caisse.avoir = vm.caisse_avoir;
        caisse.dlc = vm.caisse_dlc;
        caisse.casse = vm.caisse_casse;
        caisse.remise = vm.caisse_remise;
        caisse.commentaire = vm.commentaire;
        caisse.tarifs = vm.total_tarifs;
        
            // console.log(caisse);
        //console.log(caisse);
        WS.post('caisses', caisse)
            .then(function(response) {
                if (response.data.success == true) {
                    swal(
                        $translate.instant('Succès'),
                        $translate.instant('Caisse Modifiée avec Succès'),
                        'success'
                    ).then(function() {
                        $window.location.reload();
                    });

                } else if (response.data.success == false) {
                    swal('Error', $translate.instant(response.data.message), 'error');
                }
            })
            .then(null, function(error) {
                console.log(error);
            });
    };

    vm.getCaisseByDate = function(date_debut = null, date_fin = null, commercial = null) {
        var url = 'caisses/bydate/' + date_debut + "/" + date_fin + "/" + commercial;
        WS.get(url)
            .then(function(response) {
                if (response.status == 200) {
                    vm.caisses = response.data;
                    
                    $scope.$apply();
                }
            })
            .then(null, function(error) {
                console.log(error);
            });
    };


    vm.getCumulEcart = (date_debut = null, date_fin = null, code) => {
        WS.get('caisses/cumul/' + code + "/" + date_debut + "/" + date_fin)
            .then(function(response) {
                vm.cumul = response.data;

                jQuery.noConflict();
                $('#cumulModal').modal('show');
                $scope.$apply();
            })
            .then(null, function(error) {
                console.log(error);
            });
    };


    vm.exportCaisseByDate = function(date_debut = null, date_fin = null, commercial = null, gouvernorat = null) {
        var url = 'caisses/bydate/' + date_debut + "/" + date_fin + "/" + commercial;
        WS.get(url).then(function(response) {
            var filename = $translate.instant("Caisse By commercial") + '-' + date_debut + '-' + date_fin;

            var file = {
                sheetid: $translate.instant("Caisse By commercial") + '-' + date_debut + '-' + date_fin,
                headers: true,
                caption: {
                    title: $translate.instant("Caisse By commercial") + '-' + date_debut + '-' + date_fin,
                    style: 'font-size: 50px; color:blue;'
                },
                column: {
                    style: 'font-size:20px;background:#d1d1d1;'
                },
                columns: [

                    { columnid: 'commercial', title: 'Commercial' },
                    { columnid: 'date', title: 'Date' },
                    { columnid: 'espece', title: 'Espece' },
                    { columnid: 'cheque', title: 'Cheque' },
                    { columnid: 'credit', title: 'Credit' },
                    { columnid: 'depense', title: 'Depense' },
                    { columnid: 'carburant', title: 'Carburant' },
                    { columnid: 'entretiren', title: 'Entretien' },
                    { columnid: 'gratuite', title: 'Gratuite' },
                    { columnid: 'recouvrement', title: 'Recouvrement' },
                    { columnid: 'journee', title: 'Total' },
                    { columnid: 'recette', title: 'Recette' },
                    { columnid: 'ecart', title: 'ecart' },
                ],
                row: {
                    style: function(sheet, row, rowidx) {
                        return 'text-align:center;background:' + (rowidx % 2 ? '#fff' : '#f1f1f1') + ';height:100px!important;';
                    }
                }
            };
            alasql('SELECT * INTO XLS("' + filename + '.xls",?) FROM ?', [file, response.data]);
        }, function(error) {
            console.log(error);
        });
    };

    vm.exportCaisseByDateE = function(tableId, date_debut = null, date_fin = null, commercial = null) {
        const data = {
            date_debut,
            date_fin,
            commercial
        };
        var uri = 'data:application/vnd.ms-excel;base64,',
            template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
            base64 = function(s) { return $window.btoa(unescape(encodeURIComponent(s))); },
            format = function(s, c) { return s.replace(/{(\w+)}/g, function(m, p) { return c[p]; }) };

        var table = $(tableId),
            ctx = { worksheet: 'WireWorkbenchDataExport', table: table.html() },
            href = uri + base64(format(template, ctx));

        //
        var download_link = document.createElement('a');
        download_link.href = href;
        var title = data.date_debut + '_||_' + data.date_fin + '_||_' + data.commercial;;

        download_link.download = title + ".xls";

        document.body.appendChild(download_link);
        download_link.click();
        document.body.removeChild(download_link);

    };

    vm.selectUsers = function() {
        WS.get('users/selectUsers', vm.access)
            .then(function(response) {
                if (response.status == 200) {
                    vm.selectusers = response.data;

                    $scope.$apply();
                } else {}
            })
            .then(null, function(error) {
                console.log(error);
            });
    };

    
    vm.getRecetteByComm = function(date, commercial) {
        WS.get('caisses/recette/' + date + '/' + commercial, vm.access)
            .then(function(response) {
                if (response.status == 200) {
                    vm.recette = 0;
                    var espece = Number(response.data.espece);
                    var cheque = Number(response.data.cheque);
                    var traite = Number(response.data.traite);
                    var avoir = Number(response.data.avoir);
                    var recette = (espece + cheque + traite) + avoir;
                    vm.recette = recette;

                    $scope.$apply();
                } else {}
            })
            .then(null, function(error) {
                console.log(error);
            });
    };

    vm.getTotalRecette = function(list) {
        if (!list) return 0;
        var total = 0;
        for (var i = 0; i < list.length; i++) {
            total = total + Number(list[i]['montant']);
        }
        return total;
    }

      vm.getTotalBycolonne = function(list, type) {
        if (!list) return 0;
        var total = 0;
        for (var i = 0; i < list.length; i++) {
            total = total + Number(list[i][type]);
        }
        return total;
    }

    vm.getTotalEcart = function(list) {
        if (!list) return 0;
        var total = 0;
        for (var i = 0; i < list.length; i++) {
            total = total + Number(list[i]['ecart']);
        }
        return total;
    };

    vm.clotureCaisse = function(id){
        swal({
            title: $translate.instant("Cloture"),
            text: $translate.instant("Valider Caisse"),
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: $translate.instant('Oui'),
            cancelButtonText: $translate.instant('Non'),
            confirmButtonClass: 'btn btn-success',
            cancelButtonClass: 'btn btn-danger',
            buttonsStyling: true
        }).then(function() {

            WS.put('caisses/clotureCaisse/'+id, {cloture : 1 })
                .then(function(response) {
                    if(response.data.success==true){
                        swal(
                            $translate.instant(`Succé`),
                            $translate.instant(`Caisse validé avec succé`),
                            'success'
                        ).then(function() {
                            $window.location.reload();
                        });
                    }
                   
                })
                .then(null, function(error) {
                    console.log(error);
                });
        }).catch(function(){
            console.log('cancelled!');
        });
    };

    vm.deleteCaisse = function(id){
        swal({
            title: $translate.instant('Caisse'),
            text: $translate.instant("voulez vous vraiment supprimer cette caisse!"),
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Oui',
            cancelButtonText: 'Non',
            confirmButtonClass: 'btn btn-success',
            cancelButtonClass: 'btn btn-danger',
            buttonsStyling: false
        }).then(function() {
            WS.delete('caisses/' + id).then(
                function() {
                    swal(
                        $translate.instant('Succès'),
                        $translate.instant('Caisse supprimée avec Succès'),
                        'success'
                    ).then(function() {
                        $window.location.reload();
                    });
                },
                function() {
                    swal(
                        $translate.instant('Attention'),
                        $translate.instant('vous ne pouvez pas supprimer cette caisse'),
                        'warning'
                    );
                }
            );
        });
    };


    vm.printElementTable = function( body) {

        var mywindow = window.open('', 'PRINT');

        mywindow.document.write(`<html>
                                    <head>
                                    <title> ${document.title} </title>
                                    <style>
                                        .noprint{display: none;}.text-center{text-align:center}
                                        th{border:1px solid #ddd!important;}
                                        td{border:1px solid #ddd!important;}
                                    </style>
                                `);
        mywindow.document.write('</head><body >');
        //mywindow.document.write(document.getElementById(header).innerHTML);
        mywindow.document.write(document.getElementById(body).innerHTML);
        //mywindow.document.write(document.getElementById(footer).innerHTML);
        mywindow.document.write('</body></html>');
        mywindow.document.close(); // necessary for IE >= 10
        mywindow.focus(); // necessary for IE >= 10*/

        mywindow.print();
        mywindow.close();

        return true;
    }

}
export default {
    name: 'caisseController',
    fn: caisseController
};